"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = Close;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

function Close(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M9.33301 9.33337L22.6663 22.6667",
    stroke: "#1F2D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), (0, _core.jsx)("path", {
    d: "M22.6663 9.33337L9.33301 22.6667",
    stroke: "#1F2D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

Close.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Close"
};